export default "__VITE_ASSET__BwRYqJjz__"